import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="apps"
export default class extends Controller {
  connect() {
    document.getElementById("gallery").innerHTML = "";
    document.body.classList.remove("gallery-active");
  }
}
